import React from 'react'

import Table from 'components/Table/Table'
import Button from 'components/Forms/Button/Button'

import { copyToClipboard } from 'utils/clipboard'

import { getLocaleDetailsByCode } from 'constants/locales'

import iconCopy from 'images/icons/copy.svg'
import { MODALS } from '../../constants'

const getColumns = ({ methods }) => [
    {
        headerLabel: 'ID',
        getMarks: country => [
            {
                image: iconCopy,
                label: 'Copy to clipboard',
                onClick: () => copyToClipboard(country.id),
            },
        ],
        getTitle: country => country.id,
        getValue: country => country.id,
        width: '15%',
    },
    {
        headerLabel: 'Country code',
        getTitle: country => country.countryCode,
        getValue: country => {
            const localeDetails = getLocaleDetailsByCode(country.countryCode)
            if (localeDetails) {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                            style={{
                                border: '1px solid #000',
                                width: 22,
                                marginRight: 6,
                                borderRadius: 2,
                                boxSizing: 'border-box',
                            }}
                            src={localeDetails.icon}
                            alt="icon"
                        />{' '}
                        {country.countryCode}
                    </div>
                )
            }

            return country.countryCode
        },
        width: '25%',
    },
    {
        headerLabel: 'Currency',
        getTitle: country => country.currency,
        getValue: country => country.currency,
        width: '25%',
    },
    {
        headerLabel: 'Symbol',
        getTitle: country => country.symbol,
        getValue: country => country.symbol,
        width: '15%',
    },
    {
        getValue: country => (
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <Button
                    content="Edit"
                    variant="primary"
                    isInverse={true}
                    onClick={() => methods.onOpenModal(MODALS.EDIT_COUNTRY_CURRENCY, country)}
                />
                <Button
                    styles={{ marginLeft: 10 }}
                    content="Remove"
                    variant="danger"
                    isInverse={true}
                    onClick={() => methods.onOpenModal(MODALS.DELETE_COUNTRY_CURRENCY, country)}
                />
            </div>
        ),
        width: '20%',
    },
]

const CountryTable = ({ title, list, methods, isLoading }) => (
    <Table columns={getColumns({ methods })} isShowCounter={false} title={title} list={list} isLoading={isLoading} />
)

export default CountryTable
